import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Trophy, Users, Check } from "lucide-react";

export function ChallengeCard({ challenge, onChange }) {
  if (!challenge) return null;
  const pct = Math.round((challenge.progress / challenge.target) * 100);

  const join = async () => {
    try {
      await api.post(`/community/challenges/${challenge.category}/join`);
      toast.success("You're in. Every check-in this week counts toward it.");
      onChange();
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div className={`rounded-3xl p-5 border ${challenge.completed ? "bg-emerald-50 border-emerald-200" : "bg-gradient-to-br from-amber-50 to-orange-50 border-amber-200"}`} data-testid={`challenge-${challenge.category}`}>
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <div className="flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-amber-800">
            <Trophy className="w-3.5 h-3.5" /> {challenge.custom ? "Coach challenge" : "This week's challenge"} · {challenge.week}
          </div>
          <div className="font-display text-lg font-bold text-stone-900 mt-1 capitalize">{challenge.title}</div>
          <p className="text-xs text-stone-600 mt-1 max-w-lg">{challenge.description}</p>
          <div className="inline-flex items-center gap-1 text-xs text-stone-500 mt-2" data-testid={`challenge-participants-${challenge.category}`}>
            <Users className="w-3.5 h-3.5" /> {challenge.participants} joined · {challenge.finishers} finished · <span className="text-amber-800 font-semibold">+{challenge.points} pts</span>
          </div>
        </div>
        {!challenge.joined ? (
          <button data-testid={`challenge-join-${challenge.category}`} onClick={join} className="amber-btn text-sm">Join challenge</button>
        ) : challenge.completed ? (
          <span className="inline-flex items-center gap-1 px-4 py-2 rounded-full bg-emerald-700 text-white text-sm font-semibold" data-testid={`challenge-done-${challenge.category}`}>
            <Check className="w-4 h-4" /> Completed · badge earned
          </span>
        ) : (
          <div className="min-w-[160px]" data-testid={`challenge-progress-${challenge.category}`}>
            <div className="flex justify-between text-xs font-semibold text-stone-700 mb-1">
              <span>Progress</span><span className="font-mono">{challenge.progress}/{challenge.target}</span>
            </div>
            <div className="h-2.5 rounded-full bg-white/70 overflow-hidden">
              <div className="h-full bg-amber-600 rounded-full transition-all" style={{ width: `${pct}%` }} />
            </div>
            {!challenge.has_habits && <div className="text-[10px] text-stone-500 mt-1">Add a {challenge.category} habit to make progress.</div>}
          </div>
        )}
      </div>
    </div>
  );
}
